module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp1_8023.8baf1a3f.png";